class SectionReveal {
  constructor() {
    this.items = Array.from(document.querySelectorAll("main > section, footer"));
    this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!this.items.length) {
      return;
    }

    this.init();
  }

  init() {
    this.items.forEach((section, index) => {
      section.classList.add("section-reveal");
      section.style.setProperty("--section-reveal-index", index % 2);

      const containerChildren = Array.from(section.querySelectorAll(":scope > .container > *"));

      containerChildren.forEach((child, childIndex) => {
        child.classList.add("section-reveal__item");
        child.style.setProperty("--section-reveal-delay", `${Math.min(childIndex, 3) * 110}ms`);
      });
    });

    if (this.prefersReducedMotion || !("IntersectionObserver" in window)) {
      this.items.forEach((section) => section.classList.add("is-section-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("is-section-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: "0px 0px -18% 0px",
        threshold: 0.16,
      },
    );

    this.items.forEach((section, index) => {
      if (index === 0) {
        section.classList.add("is-section-visible");
        return;
      }

      observer.observe(section);
    });
  }
}

new SectionReveal();
